import React, { useEffect, useRef } from 'react'
import UserLists from './components/UserLists/UserLists'
import MessagesContainer from './components/MessagesContainer/MessagesContainer'
import { useState } from 'react'



const Messages = () => {
    const MessagesComponent = useRef(null)
    useEffect(() => {
        MessagesComponent.current?.scrollTo(0, MessagesComponent.current.scrollHeight);
    }, [])

    return (
        <div className='  d-flex   justify-content-start  align-items-start  flex-row' style={{
            height: '100%',
            width: '100%',
        }}>




            <UserLists ></UserLists>

            <MessagesContainer></MessagesContainer>







        </div>
    )
}

export default Messages
